export class ImpactYearly {
  constructor(
    currentYearCount,
    lastYearCount,
    twoYearsAgoCount
  ) {
    this.currentYearCount = currentYearCount
    this.lastYearCount = lastYearCount
    this.twoYearsAgoCount = twoYearsAgoCount
  }
}
